const getContent = (state, props) => {
  if (state[props.reduxEntity] && state[props.reduxEntity].active) {
    return state[props.reduxEntity].active.content;
  }
  if (props.content) {
    return props.content;
  }
  return {};
};
const getCurrentJobID = (state, props) => {
  const reduxEntity = props.reduxEntity;
  const _ref = state[reduxEntity] || {},
    _ref$active = _ref.active,
    active = _ref$active === void 0 ? {} : _ref$active;
  const _active$Job = active.Job,
    Job = _active$Job === void 0 ? {} : _active$Job;
  const _Job$id = Job.id,
    id = _Job$id === void 0 ? null : _Job$id;
  return id;
};
const getDocuments = (state, props) => {
  if (state[props.reduxEntity] && state[props.reduxEntity].active) {
    return state[props.reduxEntity].active.reportDocumentObjects || [];
  }
  return [];
};
const getFormat = (state, props) => props.format;
const getFormatContent = (state, _ref2) => {
  let format = _ref2.format;
  if (format && format.content) {
    return format.content;
  }
  return null;
};
const getFormatContentPath = (state, props) => {
  const _props$format = props.format,
    format = _props$format === void 0 ? {} : _props$format;
  return format.contentPath;
};
// const getFormatType = (state, props) => props.format.type;

const getPropOptions = (state, props) => props.options;
const getParentContentPath = (state, props) => props.parentContentPath || '/';

/**
 *  Pull the static content out of the active report
 */
const getStaticContent = (state, props) => {
  try {
    let entityType = 'ReportType';
    if (props.reduxEntity === 'issue') {
      entityType = 'IssueType';
    } else if (props.reduxEntity === 'form') {
      entityType = 'FormType';
    }
    if (state[props.reduxEntity] && state[props.reduxEntity].active && state[props.reduxEntity].active.content && state[props.reduxEntity].active.content[entityType]) {
      return JSON.parse(state[props.reduxEntity].active.content[entityType].staticContent);
    }
    return {};
  } catch (e) {
    // logger('getStaticContent error', e);
    return {};
  }
};
export { getContent, getDocuments, getFormat, getCurrentJobID, getFormatContentPath, getFormatContent, getParentContentPath, getPropOptions, getStaticContent };